import { SubjectPage } from './SubjectPage';
export default SubjectPage;
